import React from "react";
import { gql } from "@apollo/client";

import { styled, Typography, Collapse, Divider } from "@mui/material";
import { Email as EmailIcon } from "mdi-material-ui";

const Icon = () => <EmailIcon />;

const Title = ({ orderEvent }) => {
  const toAddress =
    orderEvent.to && orderEvent.to.profile && orderEvent.to.profile.email;

  return <span>Mail {/@syos\.co$/.test(toAddress) ? "reçu" : "envoyé"}</span>;
};

const InfosList = styled("ul")({
  margin: 0,
  padding: 0,
  listStyleType: "none",
});

const InfoLabel = styled("strong")(({ theme }) => ({
  color: theme.palette.primary.main,
}));

function Content({ orderEvent }) {
  const [showFullMessage, setShowFullMessage] = React.useState(false);
  const toggleShowFullMessage = () => setShowFullMessage(!showFullMessage);

  return (
    <>
      <InfosList>
        {orderEvent.from && (
          <li>
            <InfoLabel>Expéditeur :</InfoLabel>{" "}
            <span>{orderEvent.from.profile.email}</span>
          </li>
        )}
        {orderEvent.to && (
          <li>
            <InfoLabel>Destinataire :</InfoLabel>{" "}
            <span>{orderEvent.to.profile.email}</span>
          </li>
        )}
        <li>
          <InfoLabel>Sujet :</InfoLabel> <span>{orderEvent.subject}</span>
        </li>
      </InfosList>

      <Divider sx={{ mt: 2, mb: 2 }} />

      <Collapse
        in={showFullMessage}
        collapsedSize="6em"
        sx={{
          position: "relative",

          "&::after": {
            content: "''",
            display: "block",
            position: "absolute",
            left: 0,
            bottom: 0,
            width: "100%",
            height: "100%",
            backgroundImage: (t) =>
              `linear-gradient(transparent, ${t.palette.background.paper})`,
            opacity: showFullMessage ? 0 : 1,
            transition: (t) =>
              `opacity linear ${t.transitions.duration.standard}ms`,
            pointerEvents: "none",
          },
          ".pinned &::after": {
            backgroundImage: "linear-gradient(transparent, #fbc8c8)",
          },
        }}
      >
        <Typography
          component="div"
          dangerouslySetInnerHTML={{ __html: orderEvent.body }}
        />
      </Collapse>

      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a
        href="#"
        onClick={(evt) => {
          evt.preventDefault();
          toggleShowFullMessage();
        }}
        style={{
          fontSize: "small",
          float: "right",
        }}
      >
        {showFullMessage ? "masquer le message" : "afficher le message complet"}
      </a>
    </>
  );
}

const fragments = {
  orderEvent: gql`
    fragment Orders_OrderEvent_MailEvent_OrderEvent on OrderEvent {
      id

      ... on OrderEvent_Mail {
        from {
          id
          profile {
            email
            fullName
            picture
          }
        }
        to {
          id
          profile {
            email
            fullName
            picture
          }
        }
        subject
        body
      }
    }
  `,
};

const Event = {
  Icon,
  Title,
  Content,
  fragments,
};

export default Event;
